<template>
  <div class="tts_sel">
    <div class="hecheng" @click="openshow()">
      <span v-if="active && active.name"
        >{{ active.name }}-{{ active.sex }}-{{ active.language }}</span
      ><span v-if="!active.name">点击选择配音员</span>
    </div>

    <div class="tts_win" v-show="winshow">
      <div class="title">
        <span>音色选择器</span>
        <span @click="winshow = false"
          ><i class="iconfont icon-guanbi"></i
        ></span>
      </div>
      <!-- <div>筛选：</div> -->
      <div
        style="
          max-height: 600px;
          display: flex;
          flex-wrap: wrap;
          overflow-y: auto;
        "
      >
        <div v-if="loading"><center>正在读取...</center></div>

        <div v-for="(tts, i) in filterttsall" :key="i" class="tts_role">
          <span class="ttsbtn" @click="seltts(tts)"><span></span></span>
          <span class="name" @click="seltts(tts)"
            ><i class="iconfont icon-geren" :style="activation(tts.sex)"></i>
            {{ tts.name }}-{{ tts.sex }}-{{ tts.language }}</span
          >
          <span class="test" v-if="tts.url"
            ><audioplay :fileurl="tts.url"></audioplay
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import audioplay from './audioplay.vue'

export default {
  name: 't9tts',
  components: {
    audioplay
  },
  props: {
    filterSex: {
      type: String,
      required: false
    },
    ttsrole: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      winshow: false,
      t9_ttsall: [ //系统提供的全部配音员

      ],
      ttsrole2: {}
    }
  },
  created () {

    //   if(!this.ttsrole && !this.ttsrole.name)
    //   {
    // console.log('tt9tts', this.ttsrole)
    this.getttsall()
    //   }
  },
  methods: {
    //获取全部音色列表
    getttsall () {
      this.loading = true
      this.post("/audiotts/getreader", {}).then((res) => {
        this.loading = false
        // console.log(res);
        if (res.status == "200") {
          // this.$message.success('查询成功');
          this.t9_ttsall = res.data
          // console.log(res.data);
          if (res.data.length > 1) {
            // console.log(this.filterSex);
            this.ttsrole2 = this.filterttsall[0]
            // console.log('触发更改父组件yysrole', JSON.stringify(this.ttsrole))
            if (JSON.stringify(this.ttsrole) == '{}') { // 判断如果没有配音员，则默认选择第一个配音员
              this.$emit('update:ttsrole', this.ttsrole2)
            }
            // console.log('xxxxxxxxxxxxxxx',this.filterttsall);
          }
        }
        else {
          this.$message.error("获取音色失败！")
        }
      })
        .catch(() => {
          this.loading = false
        })
    },
    seltts (item) { //选择
      // this.active = item;
      this.$emit('update:ttsrole', item)
      this.winshow = false
    },
    openshow () {
      this.winshow = true
      this.getttsall()
    }
  },
  computed: {
    activation () {
      return (icontent) => {
        if (icontent === "男") {
          return { 'color': '#39f' }
        }
        else {
          return { 'color': '#F4ACB7' }
        }
      }
    },
    filterttsall () {
      if (this.filterSex) {
        return this.t9_ttsall.filter(item => item.sex == this.filterSex)
      }
      else {
        return this.t9_ttsall
      }

    },
    active () {
      // console.log('获取的tts', this.ttsrole)
      if (this.ttsrole && this.ttsrole.name) {
        return this.ttsrole
      }
      else if (this.ttsrole2) {
        return this.ttsrole2
      }
      else {
        return {}
      }

    }
  }

}
</script>

<style lang="scss" scoped>
.tts_sel {
  position: relative;
}
.hecheng {
  border: 1px #ddd solid;
  font-size: 14px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 5px;
  color: rgb(163, 163, 163);
  cursor: pointer;

  &:hover {
    color: #39f;
  }
}
.tts_win {
  position: fixed;
  width: 660px;

  background-color: #fff;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 1px 2px 5px 5px rgba(0, 0, 0, 0.2);
  z-index: 999;
  left: 50%;
  top: 50px;
  margin-left: -330px;
  justify-content: space-between;
  .title {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px #ddd solid;
    margin-bottom: 10px;
    padding-bottom: 10px;
    i {
      font-size: 18px !important;
      cursor: pointer;
    }
  }

  .tts_role {
    height: 30px;
    line-height: 30px;
    border: 1px #fff solid;
    padding: 5px;
    border-radius: 5px;
    font-size: 14px;
    width: 46%;
    &:hover {
      border: 1px #39f solid;
      .ttsbtn {
        border: 1px #39f solid;

        span {
          background-color: #39f;
        }
      }
    }
  }
  .ttsbtn {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px #ddd solid;
    margin-bottom: -3px;
    margin-right: 10px;
    cursor: pointer;

    span {
      display: block;
      background-color: #ddd;
      width: 8px;
      height: 8px;
      margin: 4px;
      border-radius: 50%;
    }

    &:hover {
      border: 1px #39f solid;

      span {
        background-color: #39f;
      }
    }
  }
  .name {
    i {
      font-size: 20px !important;
    }
  }
  .test {
    float: right;
  }
}
</style>